export default function () {
    jQuery(document).ready(function (e) {
        function t(t)
        {
            e(t).bind("click", function (t) {
                t.preventDefault();
                e(this).parent().fadeOut()
            })
        }
        e(".pagination-dropdown-toggle").click(function () {
            var t = e(this).parents(".pagination-button-dropdown").children(".pagination-dropdown-menu").is(":hidden");
            e(".pagination-button-dropdown .pagination-dropdown-menu").hide();
            e(".pagination-button-dropdown .pagination-dropdown-toggle").removeClass("active");
            if (t) {
                e(this).parents(".pagination-button-dropdown").children(".pagination-dropdown-menu").toggle().parents(".pagination-button-dropdown").children(".pagination-dropdown-toggle").addClass("open")
            }
        });
        e(document).bind("click", function (t) {
            var n = e(t.target);
            if (!n.parents().hasClass("pagination-button-dropdown")) {
                e(".pagination-button-dropdown .pagination-dropdown-menu").hide();
            }
        });
        e(document).bind("click", function (t) {
            var n = e(t.target);
            if (!n.parents().hasClass("pagination-button-dropdown")) {
                e(".pagination-button-dropdown .pagination-dropdown-toggle").removeClass("open");
            }
        })
    });
};



// WEBPACK FOOTER //
// ./themes/app/src/js/pagination.js